import { cva } from 'class-variance-authority';
export const cardStyling = cva('bg-surface-muted', {
    variants: {
        padding: {
            none: 'p-stack-section',
            sm: 'p-stack-section',
            md: 'p-stack-grid',
            lg: 'p-stack-grid',
        },
        rounding: {
            none: 'rounded-none',
            sm: 'rounded-control-sm',
            md: 'rounded-card',
            lg: 'rounded-card',
            xl: 'rounded-card',
        },
    },
    defaultVariants: {
        padding: 'md',
        rounding: 'md',
    },
});
export const cardHeaderStyling = cva('', {
    variants: {
        padding: {
            none: 'pb-0',
            sm: 'pb-stack-section',
            md: 'pb-stack-grid',
            lg: 'pb-stack-grid',
        },
    },
    defaultVariants: {
        padding: 'md',
    },
});
export const cardContentStyling = cva('bg-surface rounded-card-sm', {
    variants: {
        padding: {
            none: 'p-0',
            sm: 'p-stack-section',
            md: 'p-stack-grid',
            lg: 'p-stack-grid',
        },
    },
    defaultVariants: {
        padding: 'md',
    },
});
